<template>
    <!-- LOADER -->
    <v-sheet
        v-if="isLoading"
        width="340"
    >
        <v-skeleton-loader type="article@5"/>
    </v-sheet>
    <!-- /LOADER -->

    <!-- PROGRAM INFORMATIONS -->
    <v-container
        v-else
        dense
        fluid
        no-gutters
        class="sidebar-content"
    >
        <!-- GENERAL INFORMATIONS -->
        <div
            v-if="tags.length > 0 || strengths.length > 0"
            class="pb-10"
        >
            <h3 class="title-info-program">
                {{ $t("sidebar.program.generalInformation") }}
            </h3>
            <div :class="{'pt-4': tags.length > 0}">
                <!-- TAGS -->
                <div v-if="tags.length > 0">
                    <div
                        v-for="tag in tags"
                        :key="tag.name"
                        class="tag"
                        :style="{ 'background-color': tag.color }"
                    >
                        <label>
                            {{ tag.name }}
                        </label>
                    </div>
                </div>
                <!-- /TAGS -->

                <!-- STRENGTHS -->
                <v-list
                    v-if="strengths.length > 0"
                    :class="{'pt-4': tags.length > 0}"
                >
                    <v-list-item
                        v-for="strength in strengths"
                        :key="strength"
                        class="body-2 pt-4"
                    >
                        <v-icon>
                            icon-check
                        </v-icon>
                        <span class="ml-1">
                            {{ strength }}
                        </span>
                    </v-list-item>
                </v-list>
                <!-- /STRENGTHS -->
            </div>
        </div>
        <!-- /GENERAL INFORMATIONS -->

        <!-- AVAILABLE PLOTS -->
        <div
            v-if="programInfo.availableLots && showPlotCount"
            class="mb-10"
        >
            <h3>
                {{ $t("sidebar.program.availableLots") + ' (' + programInfo.availableLots + ')'}}
            </h3>
            <div class="pt-4">
                <v-row no-gutters>
                    <v-col
                        v-for="typology in this.typologies"
                        :key="typology.name"
                        class="pb-4"
                        cols="12"
                    >
                        <v-card
                            ref="stockCard"
                            class="lot-card habiteo-body-2"
                            :class="{ 'pl-0': typology.preview }"
                            :height="60"
                            elevation="4"
                        >
                            <v-row no-gutters>
                                <v-col
                                    v-if="typology.preview"
                                    cols="4"
                                    :style="{'height': '60px'}"
                                >
                                    <v-img
                                        :src="typology.preview"
                                        :height="60"
                                    />
                                </v-col>
                                <v-col
                                    :class="{
                                        'col-8': typology.preview,
                                        'col-12': !typology.preview
                                    }"
                                >
                                    <span
                                        class="d-flex justify-center align-center"
                                        :style="{'height': '60px'}"
                                    >
                                        {{typology.name + ' (' + typology.available + ')' }}
                                    </span>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>
            </div>
        </div>
        <!-- /AVAILABLE PLOTS -->

        <!-- ABOUT -->
        <div
            class="pb-6"
            v-if="programInfo.shortDescription"
        >
            <h3>
                {{ $t("sidebar.program.about") }}
            </h3>
            <div class="pt-4 short-description">
                <span v-html="programInfo.shortDescription"/>
            </div>
        </div>
        <!-- /ABOUT -->
    </v-container>
    <!-- /PROGRAM INFORMATIONS -->
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'ProgramInformation',
        props: [
            'handler'
        ],
        data: () => ({
            maxCardHeight: null
        }),
        computed: {
            ...mapGetters([
                'isLoading',
                'programInfo'
            ]),
            ...mapGetters('widget', [
                'showPlotCount'
            ]),
            tags() {
                let tagList = [];
                for (let key in this.programInfo.tags)
                    if (this.programInfo.tags.hasOwnProperty(key)) {
                        const tag = this.programInfo.tags[key];
                        if (tag !== null)
                            tagList.push({
                                name: key,
                                color: tag.color,
                                type: tag.type
                            });
                    }
                return tagList;
            },
            typologies() {
                let typologyList = [];
                for (let key in this.programInfo.typologies)
                    if (this.programInfo.typologies.hasOwnProperty(key)) {
                        const typo = this.programInfo.typologies[key];
                        typologyList.push({
                            name: key,
                            available: typo.available,
                            preview: typo.preview
                        });
                    }
                return typologyList;
            },
            strengths() {
                let strengthList = [];
                for (let key in this.programInfo)
                    if (this.programInfo.hasOwnProperty(key)) {
                        const strength = this.programInfo[key];
                        if (key.startsWith("strength") && strength !== null && strength !== "")
                            strengthList.push(strength);
                    }
                return strengthList;
            }
        },
        mounted() {
            this.render();
            this.$props.handler();
        },
        methods: {
            render() {
            }
        },
        watch: {
            isLoading(val) {
                if (!val) {
                    this.$nextTick(() => {
                        this.$props.handler();
                    });
                }
            }
        }
    };
</script>

<style  lang="scss">
    @import "@/assets/scss/components/_tags.scss";

</style>



// WEBPACK FOOTER //
// src/components/programInformation/ProgramInformation.vue